module.exports = __webpack_public_path__ + "static/media/headerLogo.c1034a09.png";